
import { Component, Vue } from 'vue-property-decorator';
import FolderRepository from '@/services/File-manager/folder';
import { DataTableHeader } from 'vuetify';
import CreateRootFolderModal from '@/views/pages/internal-file-manager/components/CreateRootFolderModal.vue';
import SettingDeleteModal from '@/views/pages/internal-file-manager/components/DeleteRootFolderModal.vue';
import { CreateFolderDTO, FolderEntity } from '@fenix/file-manager-entities/file-manager-entities';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    CreateRootFolderModal,
    SettingDeleteModal,
  },
  inject: ['folderRepository'],
})
export default class FoldersManagement extends Vue {
  private loading = true;
  private showModal = {
    modalCreate: false,
    modalDelete: false,
  };
  private folders: FolderEntity[] = [];
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'Private', value: 'private' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private targetFolder: FolderEntity = {} as FolderEntity;

  private folderRepository!: FolderRepository;

  async beforeMount(): Promise<void> {
    this.folders = await this.folderRepository.getRootFolders();
    this.loading = false;
  }


  private async deleteFolder(folder: FolderEntity): Promise<void> {
    this.targetFolder = folder;
    this.toggleDeleteModal();
    await this.folderRepository.deleteFolder(folder.id);
  }

  private async submitNewFolder(newFolder: CreateFolderDTO): Promise<void> {
    await this.folderRepository.createFolder(newFolder);
    this.toggleCreateModal();
  }

  private async submitDeleteFolder(folder: FolderEntity): Promise<void> {
    await this.folderRepository.deleteFolder(folder.id);
    this.toggleDeleteModal();
  }

  private toggleCreateModal() {
    this.showModal.modalCreate = !this.showModal.modalCreate;
  }

  private toggleDeleteModal() {
    this.showModal.modalDelete = !this.showModal.modalDelete;
  }
}
